import { useAccountStoreShallow } from "@/features/account-management";
import { useAuthStoreShallow } from "@/features/authentication";
import { useAppDispatch } from "@store";
import { openDialog } from "@store/dialogs";
import moment from "moment";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import PlanHasBeenCancelled from "../components/plan-has-been-cancelled-dialog";
import { EXCLUDED_PATHS } from "../constants";

export const usePlanCancelledDialog = () => {
  const cancelAt = useAccountStoreShallow((s) => s.cancelAt);
  const isAdmin = useAuthStoreShallow((s) => s.isAdmin);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const showDialog = useMemo(() => {
    return (
      cancelAt && isExpired(cancelAt) && !EXCLUDED_PATHS.test(location.pathname)
    );
  }, [cancelAt, location.pathname]);

  useEffect(() => {
    if (!showDialog) return;
    dispatch(
      openDialog({
        id: "plan-has-been-cancelled",
        content: PlanHasBeenCancelled,
        closeOnOutsideClick: isAdmin,
      }),
    );
  }, [showDialog, dispatch, isAdmin]);
};

const isExpired = (cancelAt: Date) => {
  const now = moment(new Date());
  const end = moment(cancelAt);
  return end.diff(now) < 0;
};
